import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_input.scss'

import addSubcomponents from '../utils/addSubcomponents'
import { Props, SizeNS, DivAttributes } from '../utils/types'
import FlexList from './FlexList'
import { FlexAlignNS } from './Box'

const cx = bind(styles)

interface IconLayoutProps extends Props {
  count?: number
}

const IconLayout = React.forwardRef<
  HTMLDivElement,
  DivAttributes & IconLayoutProps
>(({ className, children, count = 1, ...props }, ref) => (
  <div
    ref={ref}
    className={cx(
      'core-icon-layout',
      `core-icon-layout--count-${count}`,
      className
    )}
    {...props}
  >
    {children}
  </div>
))

export const Icons = React.forwardRef<
  HTMLDivElement,
  DivAttributes & IconLayoutProps
>(({ className, children, ...props }, ref) => (
  <FlexList
    ref={ref}
    alignItems={FlexAlignNS.center}
    className={cx('core-icon-layout__icons', className)}
    size={SizeNS.xs}
    {...props}
  >
    {children}
  </FlexList>
))

IconLayout.displayName = 'IconLayout'

Icons.displayName = 'IconLayout.Icons'

export default addSubcomponents(
  {
    Icons,
  },
  IconLayout
)
